import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 40px 40px 20px 40px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.darkGrey};
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  white-space: nowrap;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    margin: 20px 0;
    padding: 23px 5px 21px 5px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding-top: 20px;
  }
`;

export const Title = styled.h2`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    margin-left: 25px;
  }
`;

export const NavigationText = styled.button`
  display: flex;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;

export const Navigation = styled.div`
  z-index: 10;
  display: flex;
  justify-content: flex-end;
  margin-top: -30px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.TABLET})`} {
    width: 100%;
    margin: 0 0 0 -10px;
  }
`;

export const Children = styled.div`
  width: 100%;
  margin-top: 5px;
  white-space: nowrap;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    margin-top: 5px;
  }
`;

export const Arrow = styled.div`
  margin-left: 5px;
`;
